import React from 'react';
import RtccReservationTemplate from '../../components/template/RTCC/rtccReservationTemplate';
import { confirmHotelReservation, getFavoriteCondition } from "../../const/RTCC";
import MessageConst from '../../const/RTCC/messageConst';
import image_base from '../../resources/RTCC/image/img_home/rtcc_bg_000.jpg';
import common from "../../resources/RTCC/js/common/common";


class RtccReservation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 検索条件保存モーダル
            reservationPopup: false,
            popupDataList: [],
            popupData: {},
            popupMessage: "",
            popupMode: "",
            // チェックイン・アウトモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            beforeAreaId: "",
            beforeCountryId: "",
            // 海外国内フラグ
            displaySwitchTab: false,
            // おすすめ情報選択フラグ
            selectRecommendFlg: false,
            // エラー解除フラグ
            clickCount: 0,
            // 1室の大人こども人数リスト
            adultNumList: [],
            chlidNumList: []
        };
    };

    render() {
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ reservationPopup: false }); };

        // 1室あたりの年齢層リスト作成
        const createAgeCountList = (count) => {
            let adults = [];
            for (let i = 1; i <= count; i++) {
                adults.push({ id: i, value: i + "人" });
            }
            let children = [];
            for (let i = 0; i < count; i++) {
                children.push({ id: i, value: i + "人" });
            }
            this.setState({
                adultNumList: adults,
                chlidNumList: children
            });
        }

        // エラー解除用
        const onClickCountWindow = () => {
            console.log("onClickCountWindow");
            this.setState({ clickCount: this.state.clickCount + 1 });
        };

        // 検索条件保存モーダル
        const onClickOpenReservationPopupWindow = (id, loginId) => {
            this.setState({
                reservationPopup: !this.state.reservationPopup,
                popupData: {},
                popupDataList: [],
                resData: {}
            });
            let title = "";
            if (id != undefined) {
                if (id == 'savedSearch') {
                    title = "保存した検索条件"
                    common.doPost(getFavoriteCondition, { loginId: loginId }, afterGetSavedSearch);
                }
                else if (id == 'bookConfirm') {
                    title = "予約確認・変更"
                    common.doPost(confirmHotelReservation, { loginId: loginId }, afterConfirmHotelReservation);
                }
                this.setState(
                    {
                        popupMode: id,
                        popupTitle: title
                    }
                );
            }
        }
        // 保存した検索条件取得後処理
        const afterGetSavedSearch = (res) => {
            let resData = res.data;
            let dataList = [];
            if (resData.resultCode == 0) {
                let areaName = resData.destinationArea.areaName != null ? resData.destinationArea.areaName + "・" : "";
                let countryName = resData.destinationArea.countryName != null ? resData.destinationArea.countryName + "・" : "";
                let cityName = resData.destinationArea.cityName != null ? resData.destinationArea.cityName : "";

                let destination = areaName
                    + countryName
                    + cityName;
                let roomCount = resData.roomCount != "" ? resData.roomCount + "室" : "";
                dataList = [
                    // {
                    //     label: "キーワード",
                    //     text: resData.keyWord,
                    //     type: "row"
                    // },
                    {
                        label: "目的地",
                        text: destination,
                        type: "row"
                    },
                    {
                        label: "室数",
                        text: roomCount,
                        type: "row"
                    },
                ]
                this.setState(
                    {
                        popupDataList: dataList,
                        resData: resData
                    }
                );
            } else {
                this.setState(
                    {
                        popupMode: "message",
                        popupMessage: MessageConst.NOT_SAVED_SEARCH
                    }
                );
            }
        }
        // 予約情報取得後処理
        const afterConfirmHotelReservation = (res) => {
            const data = res.data;
            if (data.resultCode != 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reserve,
                    }
                );
            }
        }
        // チェックインモーダル 
        const onClickOpenCalendarWindow = (e) => {
            this.setState({ calendarPopup: !this.state.calendarPopup });
            let checkInFlg = false;
            let checkOutFlg = false;
            let title = "";
            if (e != undefined) {
                if (e.target.id == 'checkIn') {
                    checkInFlg = true;
                    checkOutFlg = false;
                    title = "チェックイン"
                }
                else if (e.target.id == 'checkOut') {
                    checkInFlg = false;
                    checkOutFlg = true;
                    title = "チェックアウト"
                }
                this.setState(
                    {
                        checkInFlg: checkInFlg,
                        checkOutFlg: checkOutFlg,
                        popupTitle: title
                    }
                );
            }
        }
        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // 詳細ポップアップ表示情報設定
        const setPopupData = (title, mode, data) => {
            this.setState({
                reservationPopup: !this.state.reservationPopup,
                popupTitle: title,
                popupMode: mode,
                popupData: data,
                resData: {}
            });
        }

        // チェックリストモーダル
        const onClickOpenCheckListWindow = (e) => {
            this.setState({ checkListPopup: !this.state.checkListPopup });
            let areaFlg = false;
            let countryFlg = false;
            let cityFlg = false;
            let title = "";
            if (e != undefined) {
                if (e.target.id == 'areaModal') {
                    areaFlg = true;
                    countryFlg = false;
                    cityFlg = false;
                    title = "エリアを選択"
                }
                else if (e.target.id == 'countryModal') {
                    areaFlg = false;
                    countryFlg = true;
                    cityFlg = false;
                    title = "国を選択"
                }
                else if (e.target.id == 'cityModal') {
                    areaFlg = false;
                    countryFlg = false;
                    cityFlg = true;
                    title = "都市を選択"
                }
                this.setState(
                    {
                        areaFlg: areaFlg,
                        countryFlg: countryFlg,
                        cityFlg: cityFlg,
                        popupTitle: title
                    });
            }

        }

        // 海外国内フラグ切替
        const setDisplaySwitchTab = (e) => {
            this.setState({ displaySwitchTab: e });
        }
        // おすすめ情報選択フラグ切替
        const setSelectRecommendFlg = (flg) => { this.setState({ selectRecommendFlg: flg }) };

        return (
            <div style={style.base} >
                <RtccReservationTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                    setPopupMode={setPopupMode}
                    setPopupMessage={setPopupMessage}
                    setPopupData={setPopupData}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    setDisplaySwitchTab={setDisplaySwitchTab}
                    setSelectRecommendFlg={setSelectRecommendFlg}
                    onClickCountWindow={onClickCountWindow}
                    createAgeCountList={createAgeCountList}
                />
            </div>
        )
    }
}
export default RtccReservation;